import React from "react"

import { Grid, Typography, Icon, Button } from "@material-ui/core"
import { CheckBox as CheckBoxIcon } from "@material-ui/icons"

import useStyles from "@/pages/Admin/Agent/UpsellAgentPage/styles"

import Breadcrumb from "@/components/BreadcrumbNew"

import AIHumanHandshakeSVGIcon from "@/assets/images/illustrations/AI_human_handshake.svg"
import AIHumanComputerSVGIcon from "@/assets/images/illustrations/AI_human_computer.svg"
import AIHuggingSVGIcon from "@/assets/images/illustrations/AI_hugging.svg"
import SuportAgentSVGIcon from "@/assets/icons/suport_agent.svg"

import PortletWithNewsContent from "@/components/PortletWithNewsContent"

import { colors } from "@/styles/colors"
import { themeColors } from "letalkui"

const UpsellAgentPage: React.FC = () => {
	const classes = useStyles()

	const CONSULTANT_LINK = "https://track.letalk.com.br/redirect-to-whatsapp/FD5B02B9C900/agente-de-ia-pagina-do-modulo-de-ia"

	const SECTION_1_ITEMS: string[] = [
		"Responda clientes automaticamente, todos os dias e em qualquer horário.",
		"Reduza o tempo de espera com respostas rápidas, consistentes e contextualizadas.",
		"Mantenha sua operação ativa mesmo fora do horário comercial.",
		"Automatize dúvidas frequentes e atendimentos repetitivos.",
		"Execute tarefas automaticamente, como agendamentos, atualização de planilhas, criação de oportunidades e muito mais."
	]

	const AI_AGENT_TYPES: Array<{
		title: string
		content: string
	}> = [
		{
			title: "Agente de Triagem",
			content: "identifica o tipo de contato e direciona automaticamente para o setor correto."
		},
		{
			title: "Agente SDR / Qualificação",
			content: "faz perguntas estratégicas e filtra leads com base em critérios definidos pelo time comercial."
		},
		{
			title: "Agente de Agendamento",
			content: "agenda automaticamente, envia lembretes e reduz no-shows."
		},
		{
			title: "Agente de Suporte",
			content: "responde dúvidas frequentes e resolve questões simples sem intervenção humana."
		},
		{
			title: "Agente de Pós-venda e Retenção",
			content: "realiza follow-ups, coleta feedbacks e incentiva a recompra."
		}
	]

	const SECTION_3_ITEMS: string[] = [
		"Identifique intenções, necessidades e oportunidades durante o atendimento.",
		"Use regras, contexto e informações da operação para conduzir melhor cada conversa.",
		"Crie uma experiência mais fluida, profissional e escalável para seus clientes."
	]

	return (
		<Grid
			container
			direction="column"
			spacing={6}
		>
			<Grid item>
				<Grid container direction="column" spacing={3}>
					<Grid item>
						<Breadcrumb
							data={[
								{ name: "Agentes de IA", pathname: "/admin/ai/agent" }
							]}
						/>
					</Grid>

					<Grid item>
						<Grid container direction="column">
							<Grid item className={classes.portlet}>
								<PortletWithNewsContent
									body={{}}
									title={{
										value: "Este recurso faz parte do módulo de Agentes de IA"
									}}
								>
									<Grid
										container
										justifyContent="center"
										direction="column"
									>
										<Typography
											variant="h1"
											className={classes.bodyText}
										>
											Você tentou acessar uma funcionalidade exclusiva do módulo Agentes de IA, que não está disponível no seu plano atual.
										</Typography>

										<Typography
											variant="h1"
											className={classes.bodyAuxiliarText}
										>
											Transforme seu atendimento com agentes inteligentes capazes de
											<br />
											<strong>automatizar conversas</strong>, <strong>qualificar contatos</strong> e <strong>apoiar sua equipe em tempo real</strong>.
										</Typography>

										<Button
											className={classes.button}
											variant="contained"
											href={CONSULTANT_LINK}
											target="_blank"
										>
											Falar com consultor
										</Button>
									</Grid>
								</PortletWithNewsContent>
							</Grid>

							<Grid item>
								<Grid container direction="column" spacing={8}>
									<Grid item>
										<Grid container direction="row">
											<Grid item xs={6}>
												<Grid container>
													<Grid item>
														<Typography className={classes.calloutTitle}>
															Atendimento inteligente 24/7
														</Typography>
													</Grid>

													<Grid item>
														<Typography>
															{SECTION_1_ITEMS.map((item, index) => (
																<Grid item xs={12} key={index}>
																	<Grid container spacing={1} className={classes.listedItem}>
																		<Grid item>
																			<Grid container alignItems="flex-start">
																				<CheckBoxIcon
																					style={{
																						width: 24,
																						height: 24,
																						fill: themeColors.colors.system.green[500]
																					}}
																				/>
																			</Grid>
																		</Grid>
																		<Grid item xs={10}>
																			<Typography>{item}</Typography>
																		</Grid>
																	</Grid>
																</Grid>
															))}
														</Typography>
													</Grid>
												</Grid>
											</Grid>

											<Grid item xs={6}>
												<img
													src={AIHumanHandshakeSVGIcon}
													className={classes.calloutImage}
												/>
											</Grid>
										</Grid>
									</Grid>

									<Grid item>
										<Grid container direction="row">
											<Grid item xs={6}>
												<img
													src={AIHumanComputerSVGIcon}
													className={classes.calloutImage}
												/>
											</Grid>

											<Grid item xs={6}>
												<Grid container direction="column" spacing={1}>
													<Grid item>
														<Typography className={classes.calloutTitle}>
															Mais eficiência para sua equipe
														</Typography>
													</Grid>

													<Grid item>
														<Typography>
															Automatize processos operacionais e permita que sua equipe foque nos atendimentos mais estratégicos.
														</Typography>
													</Grid>

													<Grid item>
														<Typography>
															{AI_AGENT_TYPES.map((AI_AGENT_TYPE, index) => (
																<Grid item xs={12} key={index}>
																	<Grid container spacing={1} className={classes.listedItem}>
																		<Grid item>
																			<Grid container alignItems="flex-start">
																				<Icon>
																					<img
																						src={SuportAgentSVGIcon}
																						style={{
																							width: 24,
																							height: 24,
																							fill: colors.getPrimaryColor()
																						}}
																						alt="ia-agent-icon"
																					/>
																				</Icon>
																			</Grid>
																		</Grid>
																		<Grid item xs={10}>
																			<Typography>
																				<strong>{AI_AGENT_TYPE.title}:</strong> {AI_AGENT_TYPE.content}
																			</Typography>
																		</Grid>
																	</Grid>
																</Grid>
															))}
														</Typography>
													</Grid>
												</Grid>
											</Grid>
										</Grid>
									</Grid>

									<Grid item>
										<Grid container direction="row">
											<Grid item xs={6}>
												<Grid container direction="column" spacing={1}>
													<Grid item>
														<Typography className={classes.calloutTitle}>
															Conversas mais organizadas e estratégicas
														</Typography>
													</Grid>

													<Grid item>
														<Typography>
															{SECTION_3_ITEMS.map((item, index) => (
																<Grid item xs={12} key={index}>
																	<Grid container spacing={1} className={classes.listedItem}>
																		<Grid item>
																			<Grid container alignItems="flex-start">
																				<Icon>
																					<img
																						src={SuportAgentSVGIcon}
																						style={{
																							width: 24,
																							height: 24,
																							fill: colors.getPrimaryColor()
																						}}
																						alt="ia-agent-icon"
																					/>
																				</Icon>
																			</Grid>
																		</Grid>
																		<Grid item xs={10}>
																			<Typography>{item}</Typography>
																		</Grid>
																	</Grid>
																</Grid>
															))}
														</Typography>
													</Grid>

													<Grid item>
														<Typography>
															Resumindo: com Agentes de IA, sua empresa atende melhor, responde mais rápido e ganha eficiência operacional sem perder qualidade e personalização no atendimento.
														</Typography>
													</Grid>
												</Grid>
											</Grid>

											<Grid item xs={6}>
												<img
													src={AIHuggingSVGIcon}
													className={classes.calloutImage}
												/>
											</Grid>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default UpsellAgentPage
